import request from '@/api/request'
import store from '@/store'

const resolveHeaders = () => {
  const region = store.getters.region || store.getters.defaultRegion
  const brand = store.getters.brand || store.getters.defaultBrand
  return {
    'X-Brand': brand,
    'X-Region': region,
  }
}

export function businessMonitoringSearch(data) {
  return request({
    url: '/businessLogMonitor/search',
    method: 'post',
    headers: resolveHeaders(),
    data,
  })
}

export function businessMonitoringCount(data) {
  return request({
    url: '/businessLogMonitor/count',
    method: 'post',
    headers: resolveHeaders(),
    data,
  })
}

export function businessMonitoringExport(data) {
  return request({
    url: '/businessLogMonitor/export',
    method: 'post',
    headers: resolveHeaders(),
    data,
    responseType: 'blob',
  })
}

export function businessMonitoringGetErrorPayload(index, id) {
  return request({
    url: `/businessLogMonitor/ERR/payload/${index}/${id}`,
    method: 'get',
    headers: resolveHeaders(),
  })
}

export function businessMonitoringDecodeStateReport(data) {
  return request({
    url: '/businessLogMonitor/decodeStateReport',
    method: 'post',
    headers: resolveHeaders(),
    data,
  })
}

export function businessMonitoringCleanUp(cleanUpTime) {
  return request({
    url: `/update/cleanUp/${cleanUpTime}`,
    method: 'post',
    headers: resolveHeaders(),
  })
}

export function businessMonitoringGetCleanUp() {
  return request({
    url: 'get/cleanUp',
    method: 'get',
    headers: resolveHeaders(),
  })
}

